import { Image, Container, Row, Col } from 'react-bootstrap';
import Img from '../Img/Cushions/Cushion_Cover_Collection_Banner.jpg';
import CircularGallery from './CircularCushnGallery';
import "./Services.css";

function Cushions() {
    return (
        <>
            <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col>
                        <h1 className='text-center my-4 text-decoration-underline'><strong>Cushions</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>Cushion covers and decorative cushions are perfect for those who want to quickly raise the level of décor in the room or want to create a warm and cosy home. Cushion covers make it easy for you to create variety in your home and can be adapted to the season. Available wide range of decorative cushions in different sizes, colours, patterns and fabrics. Mix different materials and colours and place the cushions on the sofa, armchair or on the bed to create a cosy and trendy impression.</p>
                    </Col>
                </Row>
            </Container>
            <div style={{ height: '600px', position: 'relative' }}>
                <CircularGallery bend={3} borderRadius={0.05} scrollEase={0.02} />
            </div>
        </>
    )
}

export default Cushions